import React from 'react'
import AccountHistory from 'src/app/AccountHistory/AccountHistory'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { accountHistoryRouteProps } from 'src/navigation/routeProps'

const AccountBudgetHistoryAppRoute: AppRoute = {
  id: AppLocation.AccountBudgetHistory,
  routeProps: accountHistoryRouteProps,
  component: <AccountHistory />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default AccountBudgetHistoryAppRoute
